import { useAtom } from "jotai";
import { useHydrateAtoms } from "jotai/utils";
import { rewardBannerAtom } from "../../store";
import type { RewardBannerProps } from "../../components/RewardBanner";
import type { WithMetadata } from "../../pages";

export const useSetRewardBanner = (state?: WithMetadata<RewardBannerProps>) => {
  useHydrateAtoms([[rewardBannerAtom, state]]);
};

export const useRewardBanner = () => useAtom(rewardBannerAtom);
